<template>
    <label
        class="p-0 mr-4 text-base xs:text-lg"
        :class="[center? 'label justify-center' : 'label2 justify-start']"
    >
        <input
            :value="value"
            type="checkbox"
            :checked="checked"
            :name="name"
            :disabled="disabled"
            class="checkbox checkbox-primary checkbox-xs rounded-sm mr-2 border-gray-200 bg-white"
            :class="[borderLight?'checked:border-gray-100':'checked:border-primary']"
            @input="onInput"
        >
        <slot>
            <span
                v-if="value"
                :class="[disabled&&'text-gray-100']"
            >
                {{ text }}
            </span>
        </slot>
    </label>
</template>

<script>
import { toRefs, computed } from 'vue';
export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Boolean, Number],
            required: true,
        },
        checkedValues: {
            type: [String, Boolean, Number, Array],
            required: true,
        },
        name: {
            type: String,
            default: '',
        },
        borderLight: {
            type: Boolean,
            default: false,
        },
        center: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:checkedValues'],
    setup(props, { emit }) {
        const { checkedValues, value } = toRefs(props);

        const isArray = computed(() => Array.isArray(checkedValues.value));
        const checked = computed(() => {
            return isArray.value ? checkedValues.value.includes(value.value) : checkedValues.value === value.value;
        });
        const onInput = () => {
            if (isArray.value) {
                const index = checkedValues.value.indexOf(value.value);
                index !== -1 ? checkedValues.value.splice(index, 1) : checkedValues.value.push(value.value);
                emit('update:checkedValues', checkedValues.value);
            } else {
                emit('update:checkedValues', !checkedValues.value);
            }
        };
        return { onInput, checked };
    },
};
</script>
<style scoped lang="scss">
.label {
    /* w-fit沒有效 */
    // width: fit-content;
}
.label2 {
    /* w-fit沒有效 */
    width: fit-content;
}
.checkbox-xs {
    @apply h-[0.9375rem] w-[0.9375rem];
}
</style>
